<template>
  <div>
    <disabled-activity v-if="!allowActivity" />
    <form
      @submit.prevent="onEnter"
      v-if="loggedIn && completedLogin && allowActivity"
    >
      <div class=" flex rounded-md shadow-sm">
        <textarea
          v-model="comment"
          id="about"
          rows="3"
          class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
        ></textarea>
      </div>
      <div class="mt-2">
        <span class="inline-flex rounded-md shadow-sm">
          <button type="submit" class="standard-btn" :disabled="isDisabled">
            Post
          </button>
        </span>
      </div>
    </form>
    <div class="mt-6 overflow-y-auto">
      <comment
        :comment="comment"
        v-for="(comment, idx) in comments"
        :key="idx"
        :index="idx"
        v-on:remove-comment="handleRemoveComment"
      ></comment>
    </div>
    <if-can-take-part login-class="border border-red shadow"></if-can-take-part>
  </div>
</template>

<script>
import { projectsCollection, auth, firebase } from "../utils/firebase";
import { mapGetters } from "vuex";
import Comment from "./Comment";
import DisabledActivity from "./DisabledActivity";
import { removeProjectComment } from "../utils/functions";
import IfCanTakePart from "./IfCanTakePart";

export default {
  name: "ProjectCommentArea",
  components: { IfCanTakePart, Comment, DisabledActivity },
  props: {
    sanityDocumentId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      commentsCollection: null,
      comment: "",
      comments: [],
      unsubscribe: null,
      firebaseDocumentId: ""
    };
  },
  computed: {
    ...mapGetters(["loggedIn", "completedLogin", "allowActivity"]),
    isDisabled() {
      return (
        this.comment === undefined ||
        this.comment == null ||
        this.comment.trim().length == 0
      );
    }
  },
  methods: {
    handleRemoveComment(commentID) {
      this.$store.dispatch("setDeletedMessageId", commentID);
      removeProjectComment(this.firebaseDocumentId, commentID);
    },
    onEnter() {
      // submit the message
      this.commentsCollection
        .add({
          topic: this.sanityDocumentId,
          body: this.comment,
          user: auth.currentUser.uid,
          userDisplay: auth.currentUser.displayName,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        })
        .then(docRef => console.log("Document written with ID: ", docRef.id))
        .catch(error => console.error("Error adding a document", error));
      this.comment = "";
    },
    fetchComments() {
      const vm = this;
      vm.comments = [];
      this.unsubscribe = this.commentsCollection
        .orderBy("timestamp")
        .where("topic", "==", this.sanityDocumentId)
        .onSnapshot(function(querySnapshot) {
          querySnapshot.docChanges().forEach(change => {
            let doc = change.doc;
            if (change.type === "added") {
              vm.comments.push({ id: doc.id, ...doc.data() });
            }
            if (change.type === "modified") {
              const index = vm.comments.findIndex(
                item => item.id === change.doc.id
              );
              vm.comments.splice(index, 1, { id: doc.id, ...doc.data() });
            }

            if (change.type === "removed") {
              const index = vm.comments.findIndex(
                item => item.id === change.doc.id
              );
              vm.comments.splice(index, 1);
            }
          });
        });
    }
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
  async created() {
    const sanityDocumentId = this.sanityDocumentId;
    let firebaseProjectId;
    projectsCollection
      .where("project", "==", sanityDocumentId)
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          // doc.data() is never undefined for query doc snapshots
          firebaseProjectId = doc.id;
        });
        return firebaseProjectId;
      })
      .then(firebaseProjectId => {
        this.firebaseDocumentId = firebaseProjectId;
        this.commentsCollection = projectsCollection
          .doc(firebaseProjectId)
          .collection("comments");
      })
      .then(() => {
        this.fetchComments();
      });
  }
};
</script>

<style scoped></style>
